export const DEFAULT_TASK_ID = 'default';

export const ALL_APPS_APP_PICKER_QUERY_PARAM = 'allAppsAppPicker';
export const CCPP_APP_PICKER_QUERY_PARAM = 'ccppAppPicker';
export const CCPPN_APP_PICKER_QUERY_PARAM = 'ccppnAppPicker';
export const SUBSTANCE_COLLECTION_APP_PICKER_QUERY_PARAM = 'substCollectionAppPicker';
export const SUBSTANCE_TEXTURING_APP_PICKER_QUERY_PARAM = 'substTexturingAppPicker';

export const ALL_APPS_DEFAULT_DOWNLOAD = ['PHSP', 'KCCC'];
export const CCPP_DEFAULT_DOWNLOAD = ['LRCC', 'PHSP', 'LTRM', 'KCCC'];
export const CCPPN_DEFAULT_DOWNLOAD = ['LRCC', 'PHSP', 'LTRM', 'KCCC'];
export const SUBSTANCE_COLLECTION_DEFAULT_DOWNLOAD = ['STGR', 'KCCC'];
export const SUBSTANCE_TEXTURING_DEFAULT_DOWNLOAD = ['SBSTP', 'KCCC'];

export const AUTO_DOWNLOAD_QUERY_PARAM = {
	// Query referrer=auto/ auto-with-action means that installion started due to inactivity
	QUERY_PARAM: 'referrer',
	QUERY_VALUE_AUTO: 'auto',
	QUERY_VALUE_AUTO_WITH_ACTION: 'auto-with-action'
};
export const DOWNLOAD_VIA_CCD_QUERY_PARAM = {
	// Query via_ccd=true means install using Creative Cloud binary using secondary sapcode logic
	QUERY_PARAM: 'via_ccd',
	QUERY_VALUE: 'true'
};
export const AUTO_DOWNLOAD_TIMER = 10;
export const ACTION_IDS = {
	DOWNLOAD: 'download',
	INCOMPATIBLE: 'incompatible',
	SEND_LINK: 'send-link',
	LEARN_MORE: 'learn-more',
	OK: 'ok'
};
export const LOADING_WORKFLOW = 'loading';

// Constants for categories coming from AEM
export const ALL_APPS = 'all-apps';
export const RECOMMENDED = 'recommended';

export const ALL_APPS_PLAN = 'all-apps';
export const CCPP_PLAN = 'ccpp';
export const CCPPN_PLAN = 'ccppn';
export const SINGLE_APP_PLAN = 'single-app';
export const SUBSTANCE_COLLECTION_PLAN = 'substance3d-collection'; // Includes sampler, designer, painter, stager
export const SUBSTANCE_TEXTURING_PLAN = 'substance3d-texturing'; // Includes sampler, designer, painter

export const MESSAGE_BOX_VARIANT = {
	CCD_NOT_SUPPORTED: 'ccd-not-supported',
	MUSE_EOL: 'muse-eol',
	APP_OLD_VERSION: 'app-old-version',
	PHSP_32_BIT: 'phsp-32-bit',
	INCOMPATIBLE_OS_TOAST: 'incompatible-os-toast'
};

export const FEEDBACK_RESPONSES = {
	POSITIVE: 'yes',
	NEGATIVE: 'no'
};

export const GET_HELP_OPEN_SOURCES = {
	INACTIVITY: 'inactivity',
	CC_LOGO_CLICK: 'cc-logo-click',
	GET_HELP_DOWNLOAD_PAGE: 'get-help-download-page',
	FOOTER_LINK_CLICK: 'footer-link-click',
	LOGGED_OUT_CAMPAIGN_GET_HELP_CLICK: 'logged-out-campaign-get-help-click',
	LOGGED_OUT_CAMPAIGN_CCLOGO_CLICK: 'logged-out-campaign-cclogo-click'
};

export const GET_HELP_STRINGS = {
	FAQ_HEADING: 'apps.allAppsAppPicker.getHelp.faqHeading',
	INACTIVITY_FAQ_HEADING: 'apps.allAppsAppPicker.getHelp.inactivity.faqHeading',
	CC_CLICK_FAQ_HEADING: 'apps.allAppsAppPicker.getHelp.ccClick.faqHeading',
	MORE_RESOURCES: 'apps.allAppsAppPicker.getHelp.moreResources',
	CHAT_WITH_SUPPORT: 'apps.allAppsAppPicker.getHelp.chatSupport',
	GET_HELP: 'apps.allAppsAppPicker.getHelp.getHelp',
	AST_SUPPORT_COMMUNITY: 'apps.allAppsAppPicker.getHelp.community',
	FEEDBACK_ACKNOWLEDGEMENT: 'apps.allAppsAppPicker.feedback.acknowledgment',
	FEEDBACK_QUESTION: 'apps.allAppsAppPicker.feedback.question'
};

export const QUESTION_IDS = {
	CHAT_WITH_SUPPORT: 'chat-with-support',
	ASK_SUPPORT_COMMUNITY: 'ask-support-community'
};

export const LIST_IDS = {
	FAQ_AND_HELP: 'faq-and-help',
	MORE_RESOURCES: 'more-resources'
};

export const TAGS = {
	GENERAL: 'general',
	SOURCE: {
		GENERAL: 'general',
		CCWEB: 'ccweb'
	},
	PLATFORM: {
		GENERAL: 'general',
		MAC: 'mac-os',
		WINDOWS: 'windows-os',
		LINUX: 'linux-os',
		CHROMEBOOK: 'chrome-os',
		MOBILE: 'mobile',
		'32BIT': '32-bit'
	},
	BROWSER: {
		GENERAL: 'general',
		CHROME: 'chrome-browser',
		FIREFOX: 'firefox-browser',
		SAFARI: 'safari-browser',
		EDGE: 'edge-browser',
		IE: 'ie-browser',
		NON_MAJOR_BROWSER: 'non-major-browser'
	},
	COMPATIBILITY: {
		GENERAL: 'general',
		COMPATIBLE: 'compatible',
		INCOMPATIBLE: 'incompatible',
		OLDER_VERSION_COMPATIBLE: 'older-version-compatible'
	},
	INSTALL_WORKFLOW: {
		GENERAL: 'general',
		CCD_PRESENT: 'ccd-present',
		THOR_PRESENT: 'thor-present',
		KAIZEN: 'kaizen'
	},
	PAGE: {
		GENERAL: 'general',
		APP_PICKER: 'app-picker',
		DOWNLOAD: 'download-instructions',
		INCOMPATIBLE_OS_SCREEN: 'incompatible-os-screen',
		SINGLE_APP_PLAN: 'single-app-plan',
		CAMPAIGN_PAGE: 'email-campaign'
	},
	PRODUCT: {
		GENERAL: 'general',
		KCCC: 'kccc',
		RUSH: 'rush',
		PHSP: 'phsp',
		ILST: 'ilst',
		IDSN: 'idsn',
		SPRK: 'sprk',
		PPRO: 'ppro',
		AEFT: 'aeft',
		ESHR: 'eshr',
		LRCC: 'lrcc',
		LTRM: 'ltrm',
		APRO: 'apro',
		DRWV: 'drwv',
		MUSE: 'muse',
		FLPR: 'flpr',
		CHAR: 'char',
		AUDT: 'audt',
		KBRG: 'kbrg',
		AME: 'ame',
		AICY: 'aicy',
		PRLD: 'prld',
		FUSE: 'fuse',
		FRSC : 'frsc',
		PSXUWP: 'psxuwp',
		SBSTA: 'sbsta',
		SBSTD: 'sbstd',
		SBSTP: 'sbstp',
		STGR: 'stgr'
	}
};

export const GET_HELP_ANSWER_LINKS = {
	OPEN_CHAT_SUPPORT: '#launch-jarvis',
	RESTART_DOWNLOAD: '#restart-download',
	INCOMPATIBLE_OS_APP_CATALOG: '#incompatible-os-app-catalog',
	PLACEHOLDER: '#placeholder'
};

export const PLACEHOLDER_STRINGS = {
	FILENAME: 'filename',
	APPNAME: 'appname'
};

export const GET_HELP_CALLBACK = {
	VIEW_DESKTOP_APPS: 'view-desktop-apps'
};

export const HELP_TIMEOUT = 45000;
export const AUTO_DOWNLOAD_TIMEOUT = 30000;

/**
 * The amount of time after the coach mark fades out on IE, Edge, Firefox,
 * the MessageBox toasts fade in
 */
export const DISPLAY_MESSAGE_LAG = 0;

export const PAGE_TYPE = {
	APP_PICKER: 'app-picker',
	DOWNLOAD: 'download-instructions',
	INCOMPATIBLE_OS_SCREEN: 'incompatible-os-screen'
};

export const APP_PICKER_ANALYTICS = {
	WORKFLOW: 'App Picker'
};

export const INSTALL_CCD_OS_TOAST = {
	RENDER: {
		ID: 'install_ccd_os_toast_render',
		TYPE: 'render',
		VALUE: 'No OS version supported-Install-CCD',
		SUBTYPE: 'app-toast'
	},
	CTA_CLICK: {
		ID: 'install_ccd_os_toast_click',
		TYPE: 'click',
		VALUE: 'No OS version supported-Install-CCD',
		SUBTYPE: 'app-toast'
	}
};

export const DOWNLOAD_PAGE_FOOTER_HELPFUL_LINKS = [
	{
		textId: 'apps.appPicker.incompatibleOSView.footer.resources.view-your-plan',
		id: 'view-your-plan'
	},
	{
		textId: 'apps.appPicker.incompatibleOSView.footer.resources.view-desktop-apps',
		id: 'view-desktop-apps'
	},
	{
		textId: 'apps.appPicker.incompatibleOSView.footer.resources.chat-with-support',
		id: 'chat-with-support'
	}
];

export const DOWNLOAD_PAGE_FOOTER_FAQS = {
	set1: ['what-is-ccdesktop-app', 'question-about-my-plan', 'download-my-apps-later'],
	set2: ['question-about-my-plan', 'download-my-apps-later'],
	set3: ['what-is-ccdesktop-app', 'how-do-I-update-my-os-mac-os', 'cannot-install-my-apps-incompatible-os-screen'],
	set4: ['what-is-ccdesktop-app', 'how-do-I-update-my-os-windows-os', 'cannot-install-my-apps-incompatible-os-screen'],
	set5: ['what-is-ccdesktop-app', 'cannot-download-on-chrome-os'],
	set6: ['what-is-ccdesktop-app', 'cannot-download-on-linux-machine']
};

export const DOWNLOAD_CONTROLLER_USER_SOURCE = {
	LOGGED_OUT_CAMPAIGN_PAGE: 'logged-out-campaign-page',
	LOGGED_OUT_KCCC_PAGE: 'logged-out-kccc-page', /* Trailhead page implemented for KCCC so far */
	SINGLE_APP_POST_PURCHASE_PAGE: 'single-app-post-purchase-page',
	APP_PICKER_DOWNLOAD_PAGE: 'app-picker-download-page',
	INCOMPATIBLE_OS_SCREEN: 'incompatible-os-screen'
};

export const LOGGED_OUT_CAMPAIGN_ENV_NAME = 'Email Campaign';

export const LOGGED_OUT_CAMPAIGN_WORKFLOWS = {
	DOWNLOAD: 'download',
	INSTALL: 'install',
	OPEN_FILE: 'open-file',
	ROUTE_TO_PATH: 'route-to-path',
	LAUNCH: 'launch',
	UPDATE: 'update'
};

export const LOGGED_OUT_CAMPAIGN_ANALYTICS = {
	WORKFLOW_TO_SUBCATEGORY: {
		[LOGGED_OUT_CAMPAIGN_WORKFLOWS.DOWNLOAD]: 'Download',
		[LOGGED_OUT_CAMPAIGN_WORKFLOWS.INSTALL]: 'Install',
		[LOGGED_OUT_CAMPAIGN_WORKFLOWS.OPEN_FILE]: 'Open File',
		[LOGGED_OUT_CAMPAIGN_WORKFLOWS.ROUTE_TO_PATH]: 'Route To Path',
		[LOGGED_OUT_CAMPAIGN_WORKFLOWS.LAUNCH]: 'Launch',
		[LOGGED_OUT_CAMPAIGN_WORKFLOWS.UPDATE]: 'Update'
	}
};
